import { useEffect, useState } from "react";

const KEY = "orbit_notif_center";
export const NOTIF_EVT = "orbit:notif";
export const NOTIF_KINDS = ["admin", "wholesale", "billing", "stock"];

export const readNotifs = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const write = (list) => { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 200))); window.dispatchEvent(new Event(NOTIF_EVT)); };

export const addNotif = (kind, text, meta = {}) => {
  if (!text) return;
  const list = readNotifs();
  const key = meta.key || `${kind}:${text}`;
  if (meta.key && list.some((n) => n.key === key)) return;
  write([{ id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`, kind, text, key, at: Date.now(), read: false, to: meta.to || null }, ...list]);
};
export const markAllRead = () => write(readNotifs().map((n) => ({ ...n, read: true })));
export const clearNotifs = () => write([]);

export const useNotifs = () => {
  const [list, setList] = useState(readNotifs);
  useEffect(() => {
    const h = () => setList(readNotifs());
    h();
    window.addEventListener(NOTIF_EVT, h); window.addEventListener("storage", h);
    return () => { window.removeEventListener(NOTIF_EVT, h); window.removeEventListener("storage", h); };
  }, []);
  return list;
};
